module.exports = __webpack_public_path__ + "img/rules.e0f25219.jpg";